export const events = {
  visitMarketplaceIntegrations: 'Visit marketplace integrations',
  visitMarketplaceIntegrationItem: 'Visit marketplace integration item',
  clickIntegrationSetUp: 'Click integration set up',
  clickIntegrationShowUpsellModal: 'Click integration show upsell modal',
  clickInstallIntegration: 'Click install integration',
  clickUninstallIntegration: 'Click uninstall integration',
  filterByCategory: 'Filter marketplace integrations by category',
  filterByCountry: 'Filter marketplace integrations by country availability',
  filterMarketplaceIntegrationsByInstalledStatus:
    'Filter marketplace integrations by installed status',
  focusOnSearchBar: 'Focus on marketplace integrations search bar',
  searchTextOnSearchBar: 'Search text on marketplace integrations search bar',
  integrationInstalledSuccesfully: 'Integration installed successfully',
  integrationUpdatedSuccesfully: 'Integration updated successfully',
}
